import c from './assets/sass/page.module.scss'
import cn from 'classnames'

export const Page = ({ children, isAuth }) => {
    return (
        <div
            className={cn(c.component, {
                [c.auth]: isAuth,
            })}
        >
            {children}
        </div>
    )
}
